export default "/images/crm-light.svg?3e484491d3bb0cd5525e1cf6df42a8b3";